import React from 'react';
import type { LegalSection } from '../legal/types';

interface LegalDocumentProps {
  sections: LegalSection[];
}

const LegalDocument: React.FC<LegalDocumentProps> = ({ sections }) => (
  <div className="space-y-8">
    {sections.map((section) => (
      <section key={section.id} id={section.id} className="scroll-mt-6">
        <h2 className="text-xl font-semibold text-secondary-900 dark:text-white mb-3">
          {section.title}
        </h2>
        <div className="space-y-3 text-secondary-700 dark:text-secondary-300 leading-relaxed">
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
          {section.bullets && section.bullets.length > 0 && (
            <ul className="list-disc pl-5 space-y-2">
              {section.bullets.map((item) => (
                <li key={item.slice(0, 48)}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </section>
    ))}
  </div>
);

export default LegalDocument;
